<template>
  <div class="pedal-filters">
    <h2>{{ t('common.properties') }}</h2>

    <CommonFilterAccordion
      :title="t('setup.pedal.stack')"
      icon="/icons/filters/pedal__stack.svg"
    >
      <CommonSliderFilter
        :unit="t('common.unit.mm')"
        :summary-prefix="t('setup.pedal.stack')"
        :filter="pedalStackFilter"
        @updated="search($event)"
        @summary="stackSummary = $event"
      />
    </CommonFilterAccordion>

    <FilterSummary>
      <FilterSummaryItem v-if="stackSummary">
        {{ stackSummary }}
      </FilterSummaryItem>
    </FilterSummary>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { usePedalStore } from '@/store/pedalStore'
import FilterSummary from '@/components/setup/FilterSummary.vue'
import FilterSummaryItem from '@/components/setup/FilterSummaryItem.vue'
import CommonFilterAccordion from '@/components/setup/common/CommonFilterAccordion.vue'
import CommonSliderFilter from '@/components/setup/common/CommonSliderFilter.vue'
import { CommonSliderFilterType } from '@/types/filter'

const { t } = useI18n()

const userStore = useUserStore()
const { sessionId } = storeToRefs(userStore)

const pedalStore = usePedalStore()
const { filters } = storeToRefs(pedalStore)

const loading = ref(false)

const stackSummary = ref()

const pedalStackFilter: CommonSliderFilterType = {
  value: {
    Stack: filters.value.Stack ?? 0,
  },
  min: {
    MinStack: 0,
  },
  max: {
    MaxStack: 40,
  },
}

const search = (e?: Record<string, any>) => {
  pedalStore.reset()

  if (e) pedalStore.setFilters(e)

  pedalStore.retrievePedals(sessionId?.value ?? '').then(() => {
    loading.value = false
  })
}
</script>

<style lang="scss">
.pedal-filters {
  padding: 2.4rem;

  &__choice {
    display: flex;
    align-items: center;
    background-color: var(--color-dark-10);
    border: solid 0.1rem var(--color-dark-20);
    border-radius: 0.4rem;
    padding: 1.2rem;

    &--active {
      background: linear-gradient(var(--color-primary), var(--color-secondary));
      border-color: var(--color-secondary);
    }
  }
}
</style>
